import { DocumentRequestStatusEnum } from '@enums/document-request-status.enum';

export const DOCUMENT_REQUEST_STATUS_LABEL: Record<DocumentRequestStatusEnum, string> = {
  [DocumentRequestStatusEnum.REQUESTED]: 'Demandé',
  [DocumentRequestStatusEnum.RECEIVED]: 'Transmis',
  [DocumentRequestStatusEnum.CLOSED]: 'Clôturé'
};
